// extracted by mini-css-extract-plugin
export default {"cohortSelector":"MergeCohortModal_cohortSelector__3T-Iv","mergeIcon":"MergeCohortModal_mergeIcon__5Jqsn"};